import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import {TranslateService} from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import Swal from 'sweetalert2';
import * as backInter from 'app/auth/auth-data.model';
import * as $ from 'jquery';
import * as correosPrueba from './prueba';
import { ModalInfoComponent } from "./modal-info/modal-info.component";
import { QuickPanelService } from "app/layout/components/quick-panel/quick-panel.service";

@Component({
  selector: 'editorEmail',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit {

  @ViewChild('editorMceODS') editorMce: any;
  @Output() cambiaPaso: EventEmitter<number> = new EventEmitter();

  comunicacionEditor: any;
  @Input() entradaDatos: Observable<any>;

  datosGetCorreo: any;
  htmlOriginal: string;
  asuntoCorreoOriginal: string;
  asuntoCorreo: string;
  asuntoCorreoPiloto: string;
  modoEdicion: boolean;
  pasoCompleto: boolean;
  pendienteValidacion: boolean;

  tipoCorreoTag: number;
  idiomaActual:string;
  posicionIdiomaCorreo: number;
  idiomaSel: string;

  mensajeValidacion: string;

  opciones = {
    menubar: false,
    plugins: 'print preview paste importcss searchreplace autolink save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
    toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | \
              alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | \
              forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview | \
              link codesample | ltr rtl',
    toolbar_sticky: true,
    height: 1000,
    toolbar_mode: 'sliding',
    language: 'en_US'
  };

  etiquetas = [
    // "{{company}}",
    // "{{link}}",
    // "{{date}}"
  ];

  statsCorreos: any[] = []; //0 = editable, 1 = validado, 2 = habilitado, 3 = revertido

  constructor(
    private programacionService: ProgramacionService,
    private dialog: MatDialog,
    private translateSrv: TranslateService,
    private qps: QuickPanelService
  ) { }

  ngOnInit() {
    this.cambiaIdioma();
    this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdioma(); });
    this.comunicacionEditor = this.entradaDatos.subscribe( (datos) => {
      console.log("se envio datos desde componente correos: ",datos);
      this.datosGetCorreo = datos;
      this.tipoCorreoTag = datos.tipo + 1;
      this.statsCorreos = [];
      this.datosGetCorreo.tiposCorreos.idiomas.forEach(idioma => {
        this.statsCorreos.push({status:0, mensaje:''});
      });
      // this.getTemplateGuardado();
      // this.getStatusTemplate();
    });
    // this.programacionService.getStatusProgramacion(parseInt(localStorage.getItem('fechaProducto'))).subscribe( (data: backInter.getStatusIndiv) => {
    //   if(data.estatus === 3)
    //     this.pasoCompleto = true;
    // });
    this.ocultaBrandTinyMCE(); //TMP

    // setTimeout(() => {
    //   this.colocaCorreoActual();
    // }, 2000);

  }
  ocultaBrandTinyMCE(){
    let esperaImg = setInterval(function () {
      if($(".tox-notifications-container").length && $(".tox-statusbar__branding")){
        $(".tox-notifications-container").hide();
        $(".tox-statusbar__branding").hide();
        clearInterval(esperaImg);
      }
		}, 0);
  }
  cambiaIdioma(){
    let idioma: string;
    switch (this.translateSrv.currentLang) {
      case 'en':
        idioma = 'en_US';
      break;
      case 'es':
        idioma = 'es_MX';
      break;
      case 'tr':
        idioma = 'tr_TR';
      break;
      case 'zh1': case 'zh2':
        idioma = 'zh_CN';
      break;
    }
    this.idiomaActual = idioma;
    this.opciones.language = this.idiomaActual;
  }

  eligeIdioma(indice:number){
    this.posicionIdiomaCorreo = indice
    // this.colocaCorreoActual(this.datosGetCorreo.idiomas[indice].html);
    this.getTemplateGuardado(this.datosGetCorreo.tiposCorreos.idiomas[indice].idioma);
    this.ocultaBrandTinyMCE();
  }

  getTemplateGuardado(idioma:string){
    let datos: any = {
      productoId: this.datosGetCorreo.idProducto,
      // tipo: this.datosGetCorreo.tipo
    }
    this.programacionService.empresaTemplateODS(datos,this.datosGetCorreo.idEmpresa).subscribe((respuesta:any) => {
      console.log("respGetTempEmpresa:",respuesta);
      // if (!respuesta.success) {
      //   this.getTemplateBase();
      // }
      let idx = respuesta.generalCorreos.findIndex(item => item.tipo === this.datosGetCorreo.tipo && item.idioma == idioma);

      if(idx != -1){
        this.colocaCorreoActual(respuesta.generalCorreos[idx].correo);
        // this.htmlOriginal = respuesta.generalCorreos[idx].correo;
        this.asuntoCorreo = respuesta.generalCorreos[idx].asunto;
        this.asuntoCorreoOriginal = respuesta.generalCorreos[idx].asunto;
        this.asuntoCorreoPiloto = respuesta.generalCorreos[idx].piloto;

        // this.getStatusTemplate();
      }
    });
  }
  getTemplateBase(){
    this.programacionService.getTemplate(this.datosGetCorreo).subscribe((respuesta:any) => {
      console.log("respGetTempBase:",respuesta);
      if(respuesta.success){
        this.colocaCorreoActual(respuesta.html);
      }
    });
  }
  getStatusTemplate(){
    this.programacionService.statusTemplateODS(this.datosGetCorreo.idEmpresa).subscribe((respuesta:any) => {
      if (respuesta.message == "Success") {
        console.log("respGetStat:",respuesta);

        // respuesta.correosFaltantes.forEach(correo => {
        //   if(this.datosGetCorreo.tipo == correo.tipo && localStorage.getItem('productoID') == correo.productoId){
        //     this.pendienteValidacion = true;
        //   }
        // });
      }
    });
  }

  irPaso(numPaso: number){
    this.cambiaPaso.emit(numPaso);
    this.activarEdicion(false);
    this.editorMce._editor.setContent('');
    this.pendienteValidacion = false;
    this.idiomaSel = null;
  }

  cambioEditor(e){
    console.log(e);
    console.log("var Editor:",this.editorMce);
  }

  activarEdicion(status:boolean){
    this.modoEdicion = status;
    if(this.modoEdicion){
      this.mensajeSwal(this.translateSrv.instant("CONSULTATABLA.VALIDMAIL_13"),2);
      this.editorMce._editor.setMode("design");
      this.htmlOriginal = this.editorMce._editor.getContent();
    }
    else{
      this.editorMce._editor.setMode("readonly");
    }
  }

  verInfo(){
    const dialogRef = this.dialog.open(ModalInfoComponent, {
      width: '50%'
    });
  }

  colocaCorreoActual(html:string){
    this.editorMce._editor.setContent(html);
    this.editorMce._editor.setMode("readonly");
  }

  actualizaCorreo(){
    let htmlNuevo:string = this.editorMce._editor.getContent();
    let contenidoOK = true;
    if(htmlNuevo == this.htmlOriginal && this.asuntoCorreo == this.asuntoCorreoOriginal){
      this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.SINCAMBIOS'),2);
    }
    else{
      var BreakException = {};
      try {
        this.etiquetas.forEach( (etiqueta) => {
          if(!htmlNuevo.includes(etiqueta)){
            this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.SINTAG') + etiqueta,2);
            contenidoOK = false;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
      if(contenidoOK){
        this.guardaCorreo(htmlNuevo);
      }
    }
  }

  guardaCorreo(htmlNuevo:string){
    let cuerpoCorreo: string;
    let docVirtual = document.implementation.createHTMLDocument("prueba");
    docVirtual.documentElement.innerHTML = htmlNuevo;
    let tabla2 = docVirtual.querySelectorAll(".webkit");
    console.log(tabla2);

    if(tabla2 && tabla2.length > 0){
      cuerpoCorreo = tabla2[0].innerHTML;
    }
    else{
      cuerpoCorreo = htmlNuevo;
    }

    let texto = this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.GUARDAR_1');
    // let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    // this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        let datos: any = {
          productoId: this.datosGetCorreo.idProducto,
          tipo: this.datosGetCorreo.tipo,
          html: this.editorMce._editor.getContent(),
          idioma: this.datosGetCorreo.tiposCorreos.idiomas[this.posicionIdiomaCorreo].idioma,
          asunto: this.asuntoCorreo,
          empresaId: this.datosGetCorreo.idEmpresa,
          texto: 'NOTIFICACIONES.EDITOR_EMAILS.NUEVAMODODS',
          piloto:this.asuntoCorreoPiloto,
        };
        console.log(datos);

        this.programacionService.updateTemplateODS(datos).subscribe( (respuesta:any) => {
          console.log("respuestaGuardaCorreo:",respuesta);

          if(respuesta.success){
            this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.SAVEOK_1'),1);
            this.activarEdicion(false);
            this.qps.enviaToolbar(true);
          }
        });
      }
    });
  }

  validaCorreo(opcion:number){
    let texto: string;
    let textoSuccess: string;
    switch (opcion) {
      case 1:
        texto = "CONSULTATABLA.VALIDMAIL_3";
        textoSuccess = 'CONSULTATABLA.VALIDMAIL_4';
        this.mensajeValidacion = 'CONSULTATABLA.VALIDMAIL_2';
      break;
      case 2:
        texto = "CONSULTATABLA.VALIDMAIL_10";
        textoSuccess = 'CONSULTATABLA.VALIDMAIL_11';
        this.mensajeValidacion = 'CONSULTATABLA.VALIDMAIL_11';
      break;
      case 3:
        texto = "CONSULTATABLA.VALIDMAIL_6";
        textoSuccess = 'CONSULTATABLA.VALIDMAIL_7';
        this.mensajeValidacion = 'CONSULTATABLA.VALIDMAIL_8';
      break;
    }

    // let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        let datos: any = {
          productoId: this.datosGetCorreo.idProducto,
          tipo: this.datosGetCorreo.tipo,
          validado: opcion,
          idioma: this.datosGetCorreo.tiposCorreos.idiomas[this.posicionIdiomaCorreo].idioma
        };
        this.programacionService.updateTemplateValido(datos,this.datosGetCorreo.idEmpresa).subscribe( (respuesta:any) => {
          console.log("respuestaValidaCorreo:",respuesta);

          if(respuesta.success){
            this.mensajeSwal(this.translateSrv.instant(textoSuccess),1);
            this.activarEdicion(false);
            // this.pendienteValidacion = true;
            this.statsCorreos[this.posicionIdiomaCorreo].status = opcion;
            this.statsCorreos[this.posicionIdiomaCorreo].mensaje = this.mensajeValidacion;
          }
        });
      }
    });
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

}
